export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["ACTIVE"] = "active";
    StatusEnum["SUSPENDED"] = "suspended";
    StatusEnum["BLOCKED"] = "blocked";
})(StatusEnum || (StatusEnum = {}));
//# sourceMappingURL=status.enum.js.map